import { useRouter } from 'next/router';

//types
import type { ReactNode } from 'react';

//hooks
import useUser from '@/hooks/swr/useUser';
import useUserRole from '@/utils/hooks/user/useUserRole';

//routes
import {
    ACCOUNT,
    DATA_ACCESS,
    PLATFORM_OPTIONS,
    SECURITY,
    SUBSCRIPTION,
    SUBSCRIPTION_INVOICES,
    THEMES,
    USERS_ROLES
} from '@/routes/privateRoutes';

//Components
import LoaderPage from '@/components/base/Loader/LoaderPage';

const URLS_WITHOUT_TRIAL_END = [
    ACCOUNT,
    DATA_ACCESS,
    PLATFORM_OPTIONS,
    THEMES,
    SECURITY,
    SUBSCRIPTION,
    SUBSCRIPTION_INVOICES,
    USERS_ROLES
];

const TrialRedirection = ({ children }: { children: ReactNode }) => {
    const { user } = useUser();
    const router = useRouter();
    const { isAdmin } = useUserRole();
    const urlWithoutParams = router.pathname.split('?')[0];

    if (!user?.subscribed_or_trial) {
        if (!URLS_WITHOUT_TRIAL_END.includes(urlWithoutParams)) {
            // if user isn't admin, redirect to account page instead of subscription page
            if (!isAdmin) {
                router.push(ACCOUNT);
            } else {
                router.push(SUBSCRIPTION_INVOICES);
            }
            return <LoaderPage />;
        }
    }

    return children;
};

export default TrialRedirection;
